onReady(($) => {
    $('.featured-series')
        .each((index, module) => {
            let $module = $(module)
            $('.posts-column', $module)
                .slick({
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: true,
                    dots: true,
                    prevArrow: $(".slick-prev", $module),
                    nextArrow: $(".slick-next", $module),
                    fade: false,
                    responsive: [
                        {
                            breakpoint: 564,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                            },
                        },
                    ],
                });
            $module.hover(function () {
                $('.slick-next, .slick-prev', $module)
                    .toggleClass("chevron-visible");
            });
        });
    const featuredSeriess = Array.from(document.querySelectorAll('.featured-series'))
    for (const featuredSeries of featuredSeriess) {
        const ctaButton = featuredSeries.querySelector('.cta-button')
        ctaButton && ctaButton.addEventListener('click', (event) => dataLayer.push({
            event: 'cta-click',
            interactionType: 'click',
            moduleName: featuredSeries.dataset.moduleName,
            elementContent: ctaButton.textContent.replace("\n", '')
                .trim(),
            elementType: event.target.nodeName,
            elementClasses: event.target.classList.toString(),
            destinationUrl: event.target.href,
            modulePosition: featuredSeries.dataset.modulePosition,
            distinctModulePosition: featuredSeries.dataset.distinctModulePosition,
            moduleTabPosition: featuredSeries.dataset.tabPosition,
            moduleId: featuredSeries.dataset.moduleId,
            wpLoggedIn: document.body.classList.contains('logged-in')
                .toString(),
        }))
    }
});
